module.exports = __webpack_public_path__ + "img/better-hvac-logo.3a06a796.png";